import React from 'react';

const ProcessList = ({ items }) => (
  <div className="space-y-4">
    {items.map((item, index) => {
      // Split on backticks to separate the emphasized part from the rest
      const parts = item.split(/`([^`]+)`/);
      // If there are no backticks, parts will just have one item
      const formattedText = parts.map((part, i) => {
        // Even indices are normal text, odd indices were between backticks
        return i % 2 === 1 ? (
          <span key={i} className="font-semibold text-gray-800">
            {part}
          </span>
        ) : (
          part
        );
      });

      return (
        <div key={index} className="flex items-start">
          <div className="flex-shrink-0 h-6 w-6 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 font-semibold text-sm">
            {index + 1}
          </div>
          <p className="ml-4 text-gray-600">
            {formattedText}
          </p>
        </div>
      );
    })}
  </div>
);

export default ProcessList;
